var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"oidclogin"}},[_vm._v(" OIDC 登录中... ")])
}
var staticRenderFns = []

export { render, staticRenderFns }